import { QuestionBase, QuestionOptions } from './base.question.class'

interface BooleanQuestionOptions extends QuestionOptions<boolean> {
  if?: boolean
  ifYesProceed?: boolean
  ifNoProceed?: boolean
}

export class BooleanQuestion extends QuestionBase<boolean> {
  controlType = 'boolean'
  if = true
  ifYesProceed = false
  ifNoProceed = false

  get showIfQuestions() {
    return this.ifQuestions.length > 0 && this.valid && this.value === this.if
  }

  constructor(options: BooleanQuestionOptions = {}) {
    super(options)

    if (typeof options.if === 'boolean') {
      this.if = options.if
    }

    this.ifQuestions = options.ifQuestions
    this.ifYesProceed = options.ifYesProceed || false
    this.ifNoProceed = options.ifNoProceed || false

    if (this.ifQuestions) {
      this.flex = '100%'
    }
  }
}
